import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import SubscriptionApi from '../../service/Api/subscriptionApi';

// `loaded` separates "asked and got nothing" from "haven't asked yet" — same
// reasoning as paymentsSlice's `method.loaded`. /plans needs the distinction to
// decide between its skeleton and its static fallback table.
const initialState = {
    loading: false,
    loaded: false,
    error: null,
    list: []
};

export const fetchTiers = createAsyncThunk('tiers/fetch', async (params, { rejectWithValue }) => {
    try {
        const response = await SubscriptionApi.getTiers();
        return response?.data?.data?.tiers || [];
    } catch (error) {
        // A 404 here is the ordinary "flag is off" answer, not a broken
        // deployment, so it resolves to the same rejected state as any other
        // failure and the caller falls back to the static table.
        return rejectWithValue(error?.response?.status || 'error');
    }
});

const tiersSlice = createSlice({
    name: 'tiers',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTiers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchTiers.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.list = action.payload;
            })
            .addCase(fetchTiers.rejected, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.error = action.payload || 'error';
                state.list = [];
            });
    }
});

export const getTiersState = (store) => store.tiers;
export const getTiersList = (store) => store.tiers.list;

export const getTierByKey = (store, tierKey) => store.tiers.list.find((tier) => tier.tierKey === tierKey) || null;

export const { reducer: tiersReducer } = tiersSlice;
export default tiersSlice.reducer;
